import { NullActionTypes, TimeBasedRouteInput } from 'generated/graphql-types';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface AddTimeBasedRouteData {
   startDate: Date | null;
   startTime: string | null;
   endDate: Date | null;
   endTime: string | null;
   routeExtension: ExtensionOption;
   priorityId: number | null;
   comment: string | null;
   selectAll: boolean;
   isActiveMonday: boolean;
   isActiveTuesday: boolean;
   isActiveWednesday: boolean;
   isActiveThursday: boolean;
   isActiveFriday: boolean;
   isActiveSaturday: boolean;
   isActiveSunday: boolean;
   routeExtensionNullAction: NullActionTypes;
}

export interface AddTimeBasedRouteFormData {
   timeBasedRouteId: number | null;
   startDate: Date | null;
   startTime: Date | null;
   endDate: Date | null;
   endTime: Date | null;
   routeExtension: ExtensionOption;
   priorityId: number | null;
   comment: string | null;
   selectAll: boolean;
   isActiveMonday: boolean;
   isActiveTuesday: boolean;
   isActiveWednesday: boolean;
   isActiveThursday: boolean;
   isActiveFriday: boolean;
   isActiveSaturday: boolean;
   isActiveSunday: boolean;
   routeExtensionNullAction: NullActionTypes;
}

export interface TimeBasedRouteItemView {
   timeBasedRouteId: number;
   startDate: Date | null;
   endDate: Date | null;
   startTime: Date | null;
   endTime: Date | null;
   routeExtension: ExtensionOption;
   priorityId: number;
   comment: string | null;
   selectAll: boolean;
   activeDaysString: string | null;
   isActiveFriday: boolean | null;
   isActiveMonday: boolean | null;
   isActiveTuesday: boolean | null;
   isActiveWednesday: boolean | null;
   isActiveThursday: boolean | null;
   isActiveSaturday: boolean | null;
   isActiveSunday: boolean | null;
   isDeleted: boolean;
   routeExtensionNullAction: NullActionTypes;
}

export const timeBasedRoutesFields: (keyof TimeBasedRouteInput)[] = [
   'timeBasedRouteId',
   'extensionId',
   'startDate',
   'startTime',
   'endTime',
   'endDate',
   'routeExtensionId',
   'priorityId',
   'comment',
   'isActiveMonday',
   'isActiveTuesday',
   'isActiveWednesday',
   'isActiveThursday',
   'isActiveFriday',
   'isActiveSaturday',
   'isActiveSunday',
   'routeExtensionNullAction',
];
